import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpPeriodIndicatorComponent from './adpPeriodIndicator.component';

let adpPeriodIndicatorModule = angular.module('adpPeriodIndicator', [
  uiRouter
])

.component('adpPeriodIndicator', adpPeriodIndicatorComponent)

.name;

export default adpPeriodIndicatorModule;



// WEBPACK FOOTER //
// ./src/app/components/adpPeriodIndicator/adpPeriodIndicator.js